import DealsHero from "./DealsHero";

export default DealsHero;
